import styled from '@emotion/styled'

const ApplicationName = styled.h6`
    margin: 0.35em 0;
`

export { ApplicationName }
